import ChartBase from "./ChartBase";
export class BIBoxList extends ChartBase {
    constructor() {
        super();
        this.generateBiBoxItem = () => {
            const div = document.createElement("div");
            div.className = "col";
            div.innerHTML = `
                    <div class="card h-100">
                        <div class="card-body">
                            <sva-bi-box no-loading ignored></sva-bi-box>
                        </div>
                    </div>
                `;
            return div;
        };
        this._init = () => {
            // always call this
            this._getElements();
            // add boxes
            const length = this.length;
            const row = this.wrapper.querySelector(".row");
            Array(length).fill(length).forEach(() => {
                row.appendChild(this.generateBiBoxItem());
            });
            // get box list
            this.boxList = [].slice.call(this.wrapper.querySelectorAll("sva-bi-box"));
        };
        this.updateData = (props) => {
            //set metric and question
            this._setBaseInfo(props);
            // get data and labels
            const { data } = props;
            // update value
            data.forEach((dataItem, index) => {
                this.boxList[index].updateData(dataItem);
            });
            // remove loading
            this.loading = false;
        };
    }
    set value(value) {
        if (this.valueElement) {
            this.valueElement.textContent = value;
        }
    }
    get length() {
        return parseInt(this.getAttribute("length") || "1");
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
            <div class="${this.class}" data-wrapper>
                <div class="row justify-content-center row-vertical-gutters row-cols-1 row-cols-md-2 row-cols-lg-4 row-cols-xxl-5"></div>
            </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-bi-box-list", BIBoxList);
